<template functional>
	<svg xmlns="http://www.w3.org/2000/svg" :width="props.size" :height="props.size" viewBox="0 0 130 130"><path :style="`fill: ${props.color}`" d="M65,83,42.5102,61.43936a4.80052,4.80052,0,0,1,.00048-6.99153,5.31593,5.31593,0,0,1,7.293,0L65,69.017,80.19633,54.44783a5.31593,5.31593,0,0,1,7.293,0,4.80052,4.80052,0,0,1,.00048,6.99153Z" /></svg>
</template>

<script>
export default {
	name: 'ChevronDownIcon',
	props: {
		color: {
			type: String,
			default: '#2a77a6'
		},
		size: {
			type: Number,
			default: 18
		}
	}
};
</script>